import {
  useCanQuoteCart,
  useDesignsLoaded,
  usePricing,
} from '@customink/project-service-react-components';
import { useAtomValue } from 'jotai';
import { useEffect, useState } from 'react';

import { isProjectSettledAtom } from '@/hooks/Project/useIsProjectSettled';

// represents the starting point from the customers point of view
export const useOnInitialCheckoutCycleLoad = () => {
  const {
    isLoading: isPricingLoading,
    isFetching: isPricingFetching,
    data: pricingData,
  } = usePricing();
  const isProjectSettled = useAtomValue(isProjectSettledAtom);
  const canQuoteCart = useCanQuoteCart();
  const areDesignsLoaded = useDesignsLoaded();
  const [isInitialCheckoutCycleLoad, setIsInitialCheckoutCycleLoad] =
    useState(false);

  // initial state for customer should be:
  // project settled
  // designs are loaded
  // if they can be quoted then that quote has finished

  useEffect(() => {
    // if the initial customer state has been set then don't set it again
    if (isInitialCheckoutCycleLoad) return;

    if (isProjectSettled && areDesignsLoaded) {
      // if project can't be priced then we have some error so return true
      if (!canQuoteCart) {
        setIsInitialCheckoutCycleLoad(true);
      } else {
        // can quote so it is quoting
        if (
          !isPricingLoading &&
          !isPricingFetching &&
          // does not have any quote attempt
          Object.keys(pricingData.itemized).length > 0
        ) {
          setIsInitialCheckoutCycleLoad(true);
        }
      }
    }

    // breaking project level errors should be handled outside this hook
  }, [
    isProjectSettled,
    isPricingLoading,
    areDesignsLoaded,
    canQuoteCart,
    pricingData,
  ]);

  return isInitialCheckoutCycleLoad;
};
